import UtilService from '@/services/util.service';
import { useAppLayoutStore } from '@/stores/app-layout.store';
import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import { authRoutes } from './auth.routes';
import { carrierRoutes } from './carrier.routes';
import { commonRoutes } from './common.routes';
import { hrAgRoutes } from './hr_ag.routes';
import { publicRoutes } from './public.routes';
import { subcontractorRoutes } from './subcontractor.route';
import { systemRoutes } from './system.routes';

// ...authRoutes, ...publicRoutes, ...commonRoutes
const routes: Array<RouteRecordRaw> = [
  {
    path: '',
    redirect: '/loading',
  },
  {
    path: '/loading',
    name: 'loading',
    component: () => import('@/layouts/LoadingLayout.vue'),
  },
];


export const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes,
});

export const addTenantRoutes = async () => {
  let routesToAdd: RouteRecordRaw[] = [...publicRoutes];
  const tenantType = await UtilService.getTenantType();
  console.log('Tenant type:', tenantType);
  if (!tenantType) {
    routesToAdd = [...routesToAdd, ...authRoutes];
  } else {
    const appLayoutStore = useAppLayoutStore();
    await appLayoutStore.getMenuItems();
    // Add system routes for system tenant
    switch (tenantType) {
      case 'system':
        routesToAdd = [...routesToAdd, ...systemRoutes];
        break;
      case 'carrier':

        routesToAdd = [...routesToAdd, ...carrierRoutes];
        break;
      case 'hr_ag':
        routesToAdd = [...routesToAdd, ...hrAgRoutes];
        break;
      case 'subcontractor':
        routesToAdd = [...routesToAdd, ...subcontractorRoutes];
        break;
      default:
        break;
    }
    routesToAdd.map(route => {
      if (route.name === `${tenantType}-layout`) {
        route.children?.push(...commonRoutes);
      }
    })
  }
  console.log('Routes to add:', routesToAdd);

  routesToAdd.forEach(route => {
    if (!router.hasRoute(route.name!)) {
      router.addRoute(route);
    } else {
      console.log('Route already exists: ', route.name);
    }
  });
};


export default router;
